import { AnalyticCategory, AnalyticPageActions } from './types';

export const DEFAULT_PAGE_ENTRANCE = {
  category: AnalyticCategory.Page,
  action: AnalyticPageActions.entrance,
};
